import { useId } from "react";
import type { Mode } from "../content/modes";
import type { Rank } from "../content/ranks";
import { VARIANTS, variantName } from "../content/variants";
import { ninjaSvg } from "./ninjaSvg";
import "./NinjaArt.css";

interface Props {
  rank: Rank;
  locked?: boolean;
  className?: string;
  /** Which strand's look to draw. Classic (Add) when left out. */
  variant?: Mode | undefined;
  /** Stripes on the belt. */
  stripes?: number | undefined;
}

/**
 * Renders a rank's ninja. The SVG markup comes from our own config, never
 * from user input, so injecting it as HTML is safe. A custom `image` on the
 * rank replaces the drawing.
 */
export function NinjaArt({ rank, locked = false, className, variant, stripes }: Props) {
  const id = useId().replace(/[^a-zA-Z0-9]/g, "");
  const cls = ["art", className].filter(Boolean).join(" ");
  if (rank.image) {
    return (
      <div className={cls}>
        <img
          src={rank.image}
          alt={`${variantName(variant ?? "add", rank.name)} ninja`}
          className={locked ? "locked-art" : undefined}
        />
      </div>
    );
  }
  return (
    <div
      className={cls}
      dangerouslySetInnerHTML={{
        __html: ninjaSvg(
          { ...rank, name: variantName(variant ?? "add", rank.name) },
          { locked, id: `nj${id}`, variant: variant ? VARIANTS[variant] : undefined, stripes },
        ),
      }}
    />
  );
}
